import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from '../../components/Pagination';
import { TThunkDispatch } from '../../types/redux';
import { selectCurrentPage } from '../../selectors/filters';
import { fetchBuildersInfo } from '../../actions/buildersInfo';
import { setPage } from '../../actions/filters';
import { selectPageOptions } from '../../selectors/pagination';

export function PaginationContainer() {
  const dispatch: TThunkDispatch = useDispatch();

  const options = useSelector(selectPageOptions);
  const currentPage = useSelector(selectCurrentPage);

  const handleChange = React.useCallback(
    (value: number) => {
      dispatch(setPage(value));
      dispatch(fetchBuildersInfo());
    },
    [dispatch],
  );

  if (!options.length) {
    return null;
  }

  return <Pagination value={currentPage} options={options} onChange={handleChange} />;
}
